module.exports = __webpack_public_path__ + "img/mironov.c076f34d.png";